import * as React from 'react';
import System from "src/helper/system";

const DisplayQtyMinQtyMult = (props) => {
    const { single_product } = props;
    return (
        <>
            {single_product?.QtyMin > 0 && single_product?.QtyMult > 0 &&
                <>
                    <span className='min-mult-labal'>Min:</span>{single_product.QtyMin ? System.getFormatNumber({ amount: single_product.QtyMin, maximumFractionDigits: 0, isSymbol: false, isDisplaySymbol: false }) : 0} &nbsp;
                    <span className='min-mult-labal'>Mult:</span>{single_product.QtyMult ? System.getFormatNumber({ amount: single_product.QtyMult, maximumFractionDigits: 0, isSymbol: false, isDisplaySymbol: false }) : 0} &nbsp;
                </>
            }
        </>
    );
}

export default DisplayQtyMinQtyMult;